import { Injectable } from '@angular/core';
import { AntragDtoModel, FirstBelegMandatoryConfiguration, Guid } from '@ebeihilfe/core';

import { Antrag } from '../types';

@Injectable({ providedIn: 'root' })
export class AntragDtoAssemblerService {
  public fromDto(dto: AntragDtoModel, firstBelegMandatoryConfig?: FirstBelegMandatoryConfiguration): Antrag {
    const antrag = new Antrag(firstBelegMandatoryConfig);
    antrag.setDataAfterCreationOrReset(Guid.create(dto.id), dto.concurrency);
    antrag.setAntragsType(dto.antragsArt);
    antrag.containerId = dto.containerId;
    return antrag;
  }
}
